import { VisitorID } from './components/visitor-id.js';
import { getBrowserType, initFreshNonce } from "./core/utils.js";
import { checkNewTabButtonTarget } from "./components/cta-new-tab.js";
import { initCampaign, setCampaignInfo } from "./components/journey-tracker.js";
import { trialButton } from "./components/trial-buttons.js";
import { waba } from "./components/waba-trigger.js";
import { checkChannelParams } from "./components/channel-params.js";
import { initCTAPartner } from "./components/cta-partner.js";
import { initWabaTracking } from "./components/utm-tracker.js";
import { ContactAutoTrack } from './components/auto-contact-track.js';
import { cta_trial_locale } from './components/cta-trial-locale.js';
import { initPricingFilterTrack } from './components/pricing-filter-track.js';
import { initDataLayerLinkClick } from './components/datalayer-link-click.js';
import { initInquiryForms } from './components/inquiry-form.js';
import { stickyBannerClick } from './components/sticky-banner-track.js';
import { initFormStepsTracking } from './components/form-steps-track.js';
import { initLandingIntent } from './components/landing-intent.js';



(function () {
  'use strict';

  // Propagate debug flag from mlatConfig so window.__jurnalWabaDebug is set
  // automatically when Debug Mode is enabled in WP Admin → Leads Attribution → General.
  // This means you don't need to manually set __jurnalWabaDebug in the console.
  if (window.mlatConfig && window.mlatConfig.debug === true) {
    window.__jurnalWabaDebug = true;
  }

  // Fire-and-forget: fetches a nonce that can't have come from a stale full-page
  // cache (unlike window.mlatConfig.nonce baked into the HTML). See getTrackingNonce()
  // in core/utils.js for why this matters — it's what every tracker's payload uses.
  initFreshNonce();

  const visitorID = VisitorID.init();
  if (window.__jurnalWabaDebug) console.log('Current Visitor ID:', visitorID);

  function checkStickyWABA() {
    var stickyWABA = document.querySelector('.ic-wa');
    if(!stickyWABA) {
      var scrollTop = document.querySelector('#scroll-top');
      if(scrollTop) {
        scrollTop.classList.add('alt');
      }
    }
  }

  // Bind critical click handlers immediately so UX (loader/redirect) works
  // even if async tracking bootstrap fails or is slow.
  const runCoreInits = () => {
    try { checkStickyWABA(); } catch (e) {}
    try { getBrowserType(); } catch (e) {}
    try { checkNewTabButtonTarget(); } catch (e) {}
    try { initDataLayerLinkClick(); } catch (e) {}
    // Landing intent must be decided before any WABA click can read it.
    try { initLandingIntent(); } catch (e) {}
    try { waba(); } catch (e) {}
    try { trialButton(); } catch (e) {}
    // Ensure `user_journey` is created early (before first click).
    // We'll refresh it after initWabaTracking() to incorporate waba_code/wabac_code.
    try { initCampaign(); } catch (e) {}
    try { checkChannelParams(); } catch (e) {}
    try { initCTAPartner(); } catch (e) {}
    try { cta_trial_locale(); } catch (e) {}
    try { initPricingFilterTrack(); } catch (e) {}
    try { initInquiryForms(); } catch (e) {}
    try { stickyBannerClick(); } catch (e) {}
    try { initFormStepsTracking(); } catch (e) {}
  };

  // Campaign/journey computation should run after we have a chance to set
  // `waba_code` / `wabac_code` cookies via initWabaTracking().
  const runCampaignInit = () => {
    try { initCampaign(); } catch (e) {}
  };

  const refreshCampaignInfo = () => {
    // Force a recompute after WABA cookies are ready.
    try { setTimeout(() => { try { setCampaignInfo(); } catch (e) {} }, 0); } catch (e) {}
  };

  runCoreInits();

  const _mlat = window.mlatConfig || {};

  initWabaTracking({
    csv: {
      mediumUrl: document.querySelector('#medium_file')?.value || '',
      campaignUrl: document.querySelector('#campaign_file')?.value || ''
    },
    ttlDays: _mlat.ttlDays || 31,
    debug: _mlat.debug || false,
    channelCodes: _mlat.channelCodes || {
      medium:   { 'organic direct': 'J7O', 'organic search': 'J6O' },
      campaign: { 'default': 'MJ' }
    }
  })
    .then(({ code, ccode, updated, source }) => {
      // console.log('WABA:', code, ccode, updated, source);
      runCampaignInit();
      refreshCampaignInfo();
      runCoreInits();
    })
    .catch((err) => {
      if (window.__jurnalWabaDebug) console.warn('[waba] initWabaTracking failed; continuing without it:', err);
      runCampaignInit();
      refreshCampaignInfo();
      runCoreInits();
    });

  // Defer the contact-page auto-track so its synchronous fillFields() DOM work
  // does not compete with early user interactions (INP).
  const _scheduleIdle = (fn) => {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(fn, { timeout: 2000 });
    } else {
      setTimeout(fn, 0);
    }
  };
  _scheduleIdle(() => { try { ContactAutoTrack.init(); } catch (e) {} });

})();
